<template>
  <div>
    <div class="Content">
      <event-stage-header />
      <main class="SectionContainer u-flex">
        <section :class="[{'is-loading': ui.isLoading} , 'SectionContainer-left']">
          <web-form-renderer
            v-if="event.type === 'static'"
            read-only
          />
          <dynamic-form-renderer-read-only v-else />
        </section>
        <section class="SectionContainer-right">
          <header-creation-steps
            selected="Messages"
            :event="event"
          />
          <h2>Form Messages</h2>
          <div :class="[{'is-loading': ui.messagesLoading}, 'Messages-container']">
            <p>Form Success Message</p>
            <vue-editor
              v-model="form_messages.form_submit_success"
              :editor-toolbar="editorToolbar"
            />
            <br>
            <p>Form Closed Message</p>
            <vue-editor
              v-model="form_messages.form_closed"
              :editor-toolbar="editorToolbar"
            />
          </div>
        </section>
      </main>
      <footer-creation-buttons v-if="isEventCreation">
        <template #left-aligned-buttons>
          <router-link :to="{ name: routeName, params: { id: $route.params.id }}">
            <button class="Button Button--green-outline">
              Back
            </button>
          </router-link>
        </template>
        <template #right-aligned-buttons>
          <button
            :class="[{ 'is-loading' : ui.submitLoading }, 'Button Button--green']"
            @click="handleSubmit"
          >
            Save & Continue
          </button>
        </template>
      </footer-creation-buttons>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { VueEditor } from 'vue2-editor';
import EventStageHeader from '../common/event-stage-header';
import HeaderCreationSteps from '../common/header-creation-steps.vue';
import FooterCreationButtons from '../common/footer-creation-buttons.vue';
import WebFormRenderer from '../static-web-forms/static-form-renderer.vue';
import DynamicFormRendererReadOnly from '../dynamic-web-forms/dynamic-form-renderer/dynamic-form-renderer-read-only';

export default {
  components: {
    EventStageHeader,
    HeaderCreationSteps,
    FooterCreationButtons,
    WebFormRenderer,
    DynamicFormRendererReadOnly,
    VueEditor,
  },
  data() {
    return {
      pageTitle: 'Event Name',
      selectedQuestion: {},
      ui: {
        isLoading: false,
        submitLoading: false,
        messagesLoading: false,
      },
      editorToolbar: [
        ['bold', 'italic', 'underline'],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link'],
      ],
      form_messages: {
        form_submit_success: null,
        form_closed: null,
      },
    };
  },
  computed: {
    ...mapState('events', {
      event: (state) => state.event,
    }),
    isEventCreation() {
      return this.$route.path.indexOf('create-event') > -1;
    },
    routeName() {
      return this.event.type === 'dynamic' ? 'logic-dynamic-form' : 'form-builder';
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    if (this.$route.params.id !== undefined) {
      this.ui.isLoading = true;
      this.ui.messagesLoading = true;

      this.getEvent(this.$route.params.id)
        .then(() => {
          if (this.event.is_locked) {
            this.$router.push({ name: 'event-records', params: { eventId: this.event.id } });
          } else {
            if (this.event.type === 'dynamic') {
              this.populateScreens();
            }
            this.ui.isLoading = false;
            this.populateMessages();
          }
        })
        .catch(({ data }) => {
          this.ui.isLoading = false;
          this.ui.messagesLoading = false;
          this.$bus.$emit('displayMsg', {
            text: data.message,
            type: 'warning',
          });
        });
    }
  },
  methods: {
    ...mapActions('events', ['getEvent', 'updateEvent']),
    ...mapMutations('forms', ['setFormScreens']),
    populateMessages() {
      this.form_messages = { ...this.event.form_messages };
      this.ui.messagesLoading = false;
    },
    populateScreens() {
      if (this.event.questions.length) this.setFormScreens();
    },
    handleSubmit() {
      this.ui.submitLoading = true;
      const payload = {
        ...this.event,
        form_messages: { ...this.form_messages },
      };
      this.updateEvent(payload)
        .then(() => {
          this.ui.submitLoading = false;
          if (this.event.type === 'dynamic') {
            this.$router.push({ name: 'automations-dynamic-form', params: { id: this.event.id } });
          } else {
            this.$router.push({ name: 'automations', params: { id: this.event.id } });
          }
        })
        .catch(() => {
          this.ui.submitLoading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>

.SectionContainer-left {
  background: #F7F8F9 !important;
}

.SectionContainer-right {
  position: relative;
}

.Section--flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  &::before,
  &::after {
    display: none;
  }
}
</style>
